import React from 'react';
import { FiCode, FiBookOpen, FiTarget, FiCoffee, FiBriefcase } from 'react-icons/fi';

const About = () => {
  return (
    <div className="about-page">
      <div className="page-header">
        <span className="section-label">About</span>
        <h1>The <span className="highlight">Wicked</span> Story</h1>
      </div>

      <div className="about-section">
        <h2><span className="icon"><FiCode /></span> Who I Am</h2>
        <p>
          Feed me your technical infrastructure, I can transform it into much efficient,
          fully optimized and scalable solutions.
        </p>
        <p>
          I'm a lead software engineer and a cloud solution expert based in Toronto, Ontario,
          with deep expertise in cloud infrastructure optimization, AI-driven development,
          and enterprise software engineering. With a Master's in Information Technology
          from Deakin University, I've spent my career building systems that are not just
          functional — but exceptional.
        </p>
        <p>
          "The Wicked Engineer" isn't just a name — it's a mindset. It's about solving
          wicked problems with elegant solutions. Refusing to accept "good enough" when
          something can be great.
        </p>
      </div>

      <div className="about-section">
        <h2><span className="icon"><FiBriefcase /></span> What I've Done</h2>
        <p>- 10+ years of experience implementing software projects from initial planning to market — requirements, analysis, technical translation, and delivery.</p>
        <p>- Led development project teams covering plan, design, technical requirements writing, and managing activities through to production.</p>
        <p>- Developed AI-based machine learning algorithms using Azure cloud services — data mining, evaluation, and predictive modelling.</p>
        <p>- Domain experience across manufacturing plant automation, insurance, and finance sectors.</p>
        <p>- Received client recognition for consistently delivering projects on time with quality outcomes.</p>
        <p>- Pursuing Azure Software Architect Expert certification and Google Project Management certification.</p>
        <p>- Extensive Azure cloud experience — building, maintaining, and enhancing org-wide applications.</p>
        <p>- 7+ years across C#, .NET, JavaScript (Angular), Python, jQuery, MS SQL Server, NoSQL databases, and more.</p>
        <p>- Used big data platforms for analysis, processing, and extraction from large, complex datasets.</p>
        <p>- Master's degree in Software Development &amp; IT Security (2 years).</p>
        <p>- Strong ability to work independently or as part of a team with the highest levels of professionalism.</p>
      </div>

      <div className="about-section">
        <h2><span className="icon"><FiTarget /></span> What I Write About</h2>
        <p>
          This blog covers the full spectrum of modern software engineering — from AI-based
          application development and cloud architecture to system design and developer
          productivity. Every post is grounded in real experience, built on the belief that
          great software is delivered faster when humans and AI work together.
        </p>
      </div>

      <div className="about-section">
        <h2><span className="icon"><FiBookOpen /></span> Skills & Technologies</h2>
        <div className="skills-grid">
          {[
            'Any programming language with AI',
            'C#', '.NET', 'AngularJS', 'SQL Server',
            'JavaScript', 'TypeScript', 'React', 'Node.js',
            'Python', 'Redis', 'Azure DevOps', 'Azure AI',
            'Docker', 'Kubernetes', 'AWS', 'System Design',
            'CI/CD', 'GraphQL', 'Microservices',
          ].map((skill) => (
            <span key={skill} className="skill-tag">{skill}</span>
          ))}
        </div>
      </div>

      <div className="about-section">
        <h2><span className="icon"><FiCoffee /></span> Beyond Code</h2>
        <p>
          When I'm not building software, I'm probably reading about it, discussing it,
          or thinking about how it can be done better. I believe in open source, knowledge
          sharing, and the idea that a rising tide lifts all boats.
        </p>
        <p>
          Got a question or want to collaborate? Reach out through any of the links on the sidebar.
        </p>
      </div>
    </div>
  );
};

export default About;
